
<script >
import ItemsApi from "@/services/items-api";
import sizeComponent from "@/components/sizeComponent.vue"
import ColorComponent from "@/components/ColorComponent.vue"
import simplebar from "simplebar-vue";



export default ({
    name: "ElementsLookMenu",
    components: {
        sizeComponent ,ColorComponent ,simplebar
    },

    props: {
        itemRef: String,
    },

    computed: {
        findSelectedItem() {
    const selectedItem = this.lookItems.find(item => {
        if (item.sizes[this.selectedSize]) {
            for (const sizeItem of item.sizes[this.selectedSize]) {
                if (sizeItem.id === this.selectedVariant.id) {
                    return true; 
                }
            }
        }
            return false; 
        });

        return selectedItem.ref;
    } ,

    },

    mounted() {
        this.getLookItems(this.itemRef)
    },

    data() {
        return {
            selectedItem: null ,
            lookItems :null ,
            selectedListSize : 0 ,
            ItemSelected: new Set([]),
            ItemVariantSelected: new Set([]),

            isShowSize: false ,
            isShowColor:false ,

            cartSubTotal: null ,

            selectedSize: null,
            selectedVariant: null,

            isLookLoading: false,

            fields: [
              { key: "image", label: "" ,tdClass: "text-center align-middle ", tdStyle:"width:20px;",thStyle:"width:20px;" },
              { key: "title", label: "", tdClass: "text-left font-size-14 ", tdStyle:"width:20px;" ,thStyle:"width:50px;"},
              { key: "action", label: "", tdClass: " font-size-14 text-right align-middle pr-4", thStyle:"width:100px;"},

        ],
        }
    },
    methods: {

        getListOfIdsById( id) {
            const item = this.lookItems.find(item => item.id === id);
            if (!item) {
                return [];
            }

            const ids = [];
            for (const sizeKey in item.sizes) {
                const size = item.sizes[sizeKey];
                size.forEach(subItem => {
                ids.push(subItem.id);
                });
            }
            return ids;
        },

        setSize(item){
            this.selectedItem = item;
            this.isShowSize = true 
        },

        setItemVarianteIds() {
            if (!this.ItemVariantSelected.has( this.selectedVariant.id)) {
                this.ItemVariantSelected.add( this.selectedVariant.id);
            } 
        
            this.selectedListSize = this.ItemVariantSelected.size

            this.handleCheckbox()
        },
      
        handleCheckbox() {

            if (!this.ItemSelected.has( this.findSelectedItem)) {
                this.ItemSelected.add( this.findSelectedItem);
            }
            this.getPriceItemsLook() 
        },

        remove(item){
            if (this.ItemSelected.has( item.ref)) {
            this.ItemSelected.delete(item.ref);
             }

            const ids = this.getListOfIdsById(item.id);
            ids.forEach(id => {
                if (this.ItemVariantSelected.has(id)) {
                this.ItemVariantSelected.delete(id);
                }
            });

            this.selectedListSize = this.ItemVariantSelected.size
            this.getLookItems(this.itemRef)
        },

        getLookItems(itemRef){
            this.isLookLoading = true;
            ItemsApi.getLookItems(itemRef).then(
                (result) => {
                    this.lookItems=result.list;
                    this.cartSubTotal = result.cartSubTotal ;
                }
            ).finally(() => {
                this.isLookLoading = false;
            })
        },

        getPriceItemsLook(){
            let itemIds = Array.from(this.ItemVariantSelected);    
                ItemsApi.getPriceItemsLook(itemIds.join(',')).then(
                    (result) => {
                        this.cartSubTotal = result.cartSubTotal ;
                    }
                )
        },

        isChecked(item){
            return this.ItemSelected.has(item.ref) ? 1 : 0
        },

        handleClose() {
        this.$emit('close');
        },

        updateSelectedSize(size) {
            this.selectedSize = size;
            this.isShowSize=false;
            this.isShowColor=true;
        },

        updateSelectedColor(color) {
            this.selectedVariant = color;
            this.isShowColor=false;
            this.setItemVarianteIds()
        },

        onColorComponentMouseOver(variant) {
            this.selectedImage = variant.image;
        },

        onCloseColorComponent() {
            this.isShowSize=true;
            this.isShowColor=false;
        },

        addToCart() {
            const selectedItemIds = Array.from(this.ItemVariantSelected).map(item => Number(item));

            if (!selectedItemIds.length) {
                return; 
            }
            const cartItems = selectedItemIds.map(id => ({ itemVariantId: id, quantity: 1 }));
            this.$store.dispatch('addToCart', cartItems);
        }

    }
})
</script>
  

<template>
    
    <div class="elementslookmenu">
    <div class="main-padding mb-1">

        <div class="row">
            <div class="col-10 font-size-24 font-weight-bold">
                Acheter tout le look
            </div>
            <div class="col-2 text-right" @click="handleClose()" style="cursor: pointer;" > 
                <img width="10px" class="my-auto text-center" src="@/assets/icons/union.svg">
            </div>
        </div>

    </div>

    <simplebar style="min-height:30%;max-height:70% ;" class="mainmenu pt-4" > 
         <div  class="scrollmenu">
            <b-table
                    borderless 
                    :busy="isLookLoading"
                    :items="lookItems"
                    :fields="fields"
                    tbody-tr-class=" "
                    >

                    <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="dark" role="status"></b-spinner>
                    </div>
                    </template>

                    <template v-slot:cell(image)="{item}">
                        <img class="imageClass" v-bind:src="'/api/image/get/product/small/' + item.image"  height="130" width="100" alt="" />
                    </template>

                    <template v-slot:cell(title)="{ item }">
                        <div :style="{ width: '300px' }">
                            <div class="font-size-16 text-dark font-weight-bold"><a :href="'/catalogue' + item.url">{{ item.title }}</a></div>
                            <div v-if="(!isShowSize && !isShowColor) || !selectedItem || selectedItem !== item">
                                <b-button variant="outline" size="sm" class="font-size-14 text-dark p-0 pb-1" @click="setSize(item)">Choisir la taille
                                    <img class="my-auto text-center" src="@/assets/icons/small-angle-right.svg">
                                </b-button>
                            </div>
                            <div v-if=" isShowSize && item === selectedItem" class="mt-1 mb-1">
                                <sizeComponent :sizes="item.sizes" @size-selected="updateSelectedSize"></sizeComponent>
                            </div>
                            <div v-if="!isShowSize && isShowColor && item === selectedItem" class="bottomComponent mt-1 mb-1">
                                <ColorComponent :sizesList="item.sizes" :selectedSize="selectedSize" @mouseover="onColorComponentMouseOver" @color-selected="updateSelectedColor" @close="onCloseColorComponent"></ColorComponent>
                            </div>
                            <div class="font-size-16 text-dark font-weight-bold">{{ item && item.priceDiscounted ? item.priceDiscounted : '' }} <span v-if="item.discount" class="ml-1 discountLabel-micro">{{ item.discountStr }}</span> </div>
                        </div>
                    </template> 
                    <template v-slot:cell(action)="{ item }">
                    <img  v-if="isChecked(item) == 1"  class="my-auto text-center pr-2" src="@/assets/icons/checkbox-checked.svg" style="cursor: pointer;" @click="remove(item)">
                    <img  v-else  class="my-auto text-center pr-2" src="@/assets/icons/checkbox.svg" style="cursor: pointer;" @click="setSize(item)">
                    </template> 
            </b-table>
        </div> 
    </simplebar>
    



            <div class="add-to-cart-min-height" style="margin-bottom: 10%;
                        position: fixed;
                        bottom: 0px;
                        margin-left: 5%;
                        border: 1px solid rgb(203, 203, 203);
                        width: 90%;
                        height: 154px;
                        padding: 16px;
                        border-radius: 6px;
                        gap: 16px;
                        background-color: rgb(255, 255, 255);">
            
                <div class="row" >
                    <div class="col-6 col-lg-6 text-left  font-size-16 text-dark font-weight-bold">Total </div>
                    <div class="col-6 col-lg-6  font-size-16 text-dark font-weight-bold "> {{ cartSubTotal ? cartSubTotal : ""  }}</div>

                </div>
                <b-button  variant="dark" class="getStarted1 font-size-18 text-dark font-weight-bold btn-block mt-5 " @click="addToCart()">Ajouter au Panier {{ selectedListSize != 0 ? "( "+ selectedListSize+" )" : "" }} </b-button>

            </div>

        
    </div>
</template>

<style scoped>
::v-deep thead {
    display: none;
}



.b-table tbody tr:not(:last-child) {
  border-bottom: 1px solid #ddd !important; /* Use !important cautiously */
}

.elementslookmenu {
    position: fixed; 
    top: 55%; 
    right: 0px; 
    transform: translateY(-50%); 
    background-color: #fff;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.04);
    width: 27%;
    height: 95%;
    overflow: hidden;
    text-align: right;
    font-size: 14px;
    color: #121212;
    font-family: 'Space Grotesk';
    z-index: 999;
}

@media (max-width: 1200px) {
    .elementslookmenu {
        position: fixed; 
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        overflow: auto;
        transform: none; 
        background-color: #fff;
        box-shadow: none;
        overflow: auto;
        text-align: right;
        font-size: 14px;
        color: #121212;
        font-family: 'Space Grotesk';
        z-index: 999;
    }
}

@media (max-height: 500px) {
    .add-to-cart-min-height {
        display: none;
    }
}

.main-padding {
    text-align: left;
    padding-top: 4%;
    padding-left: 4%;
    padding-right: 4%;
}

.discountLabel-micro {
    border-radius: 8px;
    background-color: #ff0000;
    font-size: 12px;
    line-height: 20px;
    font-weight: bold;
    color: #fff;
    padding: 1px 4px 1px 4px;
}

</style>
  